import type { Session } from "@supabase/supabase-js";
import { create } from "zustand";
import { supabase } from "@/lib/supabase";

type Status = "loading" | "authenticated" | "anonymous";

interface SessionState {
  session: Session | null;
  status: Status;
  setSession: (session: Session | null) => void;
}

export const useSession = create<SessionState>((set) => ({
  session: null,
  status: "loading",
  setSession: (session) =>
    set({ session, status: session ? "authenticated" : "anonymous" }),
}));

/**
 * Se llama una vez al arrancar. La suscripcion mantiene el estado al dia
 * cuando el token se refresca solo o cuando la sesion se cierra en otra
 * pestana.
 */
export function initAuth(): () => void {
  void supabase.auth.getSession().then(({ data }) => {
    useSession.getState().setSession(data.session);
  });

  const { data } = supabase.auth.onAuthStateChange((_event, session) => {
    useSession.getState().setSession(session);
  });

  return () => data.subscription.unsubscribe();
}

export const useUserId = () => useSession((s) => s.session?.user.id ?? null);
